// Plain-text preview helper. Trivial today, but lives here so plain_text has
// the same parser shape as other file types and is easy to extend (e.g. line
// counts, encoding detection).

export interface TextPreview {
  snippet: string;
  truncated: boolean;
}

export interface TextPreviewOptions {
  maxChars?: number;
}

const DEFAULT_MAX_CHARS = 800;

export const parseTextPreview = (
  text: string,
  truncated: boolean,
  { maxChars = DEFAULT_MAX_CHARS }: TextPreviewOptions = {},
): TextPreview => ({
  snippet: text.slice(0, maxChars),
  truncated,
});
